import { useEffect, useState } from 'react';
import { Modal } from '../_common';
import styled from '@emotion/styled';
import PolarisIcon from '../_common/PolarisIcon';
import axios from '@/_utils/axios';
import { useAppSelector } from '@/redux/hooks';
import { selectUserEmail } from '@/redux/selectors/authSelectors';
import { Box } from '@mui/material';
import { InventoryFileEntity } from '@/redux/slices/slice_types';

interface SigniantUploadProps {
  open: boolean;
  onClose: () => void;
  file: InventoryFileEntity;
}

const DownloadConnectorModal = ({ file, open, onClose }: SigniantUploadProps) => {
  const [iframeUrl, setIframeUrl] = useState<string>('');
  const [iframeError, setIframeError] = useState<boolean>(false);
  const userEmail = useAppSelector(selectUserEmail) || 'tmtuser@tmtinsights.com';
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!iframeUrl && open) {
      generateIframeUrl();
    } else if (!open) {
      setIframeUrl('');
    }
  }, [open]);

  useEffect(() => {
    if (iframeUrl) {
      generateIframeUrl();
    }
  }, [open]);

  const generateIframeUrl = () => {
    setLoading(true);
    axios
      .post(`vfs/file_sources/${file?.file_origin_id}/download_info/${file?.download_connector_name}/`, {
        input_data: {
          files: [
            {
              path: file?.file_path,
              is_directory: false
            }
          ],
          email: userEmail
        }
      })
      .then((response) => {
        setIframeUrl(response.data?.data?.url);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleIframeError = () => {
    setIframeError(true);
  };

  return (
    <StyledModal loading={loading} open={open} title="Download File from Connector" onClose={onClose} icon={<PolarisIcon icon="cloud_upload" />}>
      {iframeError ? (
        <div>
          <p>
            Unable to load the upload page due to Content Security Policy restrictions. Please{' '}
            <a href={iframeUrl} target="_blank" rel="noopener noreferrer">
              click here
            </a>{' '}
            to open it in a new tab.
          </p>
        </div>
      ) : (
        <div>
          <iframe src={iframeUrl} width="100%" height="550px" onError={handleIframeError} />
        </div>
      )}
    </StyledModal>
  );
};

export default DownloadConnectorModal;

const StyledModal = styled(Modal)`
  & > .MuiPaper-root {
    max-width: 800px;
  }

  iframe {
    border: 1px solid ${({ theme }) => theme.palette.divider};
  }
`;

const StyledBox = styled(Box)`
  background: ${({ theme }) => theme.palette.info.main}3a;
  padding: ${({ theme }) => theme.spacing(1.5, 3)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;

  & .MuiFormControlLabel-label {
    font-size: 1.2rem;
  }
`;
